<ion-calendar
  [(ngModel)]="dateRange"
  [options]="options"
  [type]="type"
  [format]="'YYYY-MM-DD'"
  (selectStart)="onSelectStart($event)"
  (selectEnd)="onSelectEnd($event)"
  (select)="onSelectedSingleDate($event)"
>
</ion-calendar>
